import React, { memo, useContext, useMemo } from "react";

// contexts
import { CartContext } from "@cart-client/contexts/CartContext";

// types
import { PresentationInfo, CroutonComms, ReinforcementComms } from "@swiggy-private/cart-types";

// utils
import { getNestedValue, isEmpty } from "@swiggy-private/js-utils";

// components
import { BlackMembershipWidgets } from "@swiggy-private/super-ui";
import { useBlackOtpWidgetsAnalytics } from "@cart-client/hooks/useBlackOtpWidgetsAnalytics";

const BlackMembershipNudgesWrapper = () => {
    const { cartState } = useContext(CartContext);
    const { reviewedCart: cartResponse } = cartState;

    const swiggyPlanInfo = useMemo(
        () => getNestedValue(cartResponse, "data.swiggyOneInfo.presentationInfo", {} as PresentationInfo),
        [cartResponse],
    );
    const croutonComms = useMemo(() => getNestedValue(swiggyPlanInfo, "crouton_comms") as CroutonComms, [
        swiggyPlanInfo,
    ]);

    const analyticsEvents = useBlackOtpWidgetsAnalytics(croutonComms);

    const blackMembershipWidgetProps = useMemo(() => {
        const reinforcementComms = getNestedValue<ReinforcementComms | undefined>(
            swiggyPlanInfo,
            "reinforcement_comms",
        );

        return {
            reinforcementComms,
            croutonComms,
            shouldBlackCroutonMount: true,
            analyticsEvents,
        };
    }, [analyticsEvents, croutonComms, swiggyPlanInfo]);

    if (isEmpty(blackMembershipWidgetProps.reinforcementComms) && isEmpty(blackMembershipWidgetProps.croutonComms)) {
        return null;
    }

    return <BlackMembershipWidgets {...blackMembershipWidgetProps} />;
};

export default memo(BlackMembershipNudgesWrapper);
